module.exports = __webpack_public_path__ + "img/max-wallet.65a8b710.png";